module.exports = __webpack_public_path__ + "media/images/ms-icon-144x144-e8b238c6.png";